// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_qe-5";
export var filledCircle = "_qe-4";
export var historyEntry = "_qe-3";
export var messageSideLeft = "_qe-1";
export var messageSideRight = "_qe-2";
export var orderTrackingCarouselWrapper = "_qe-6";
export var orderTrackingInfoContainer = "_qe-0";